import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import { toString } from 'lodash';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { StatusNames } from '@/modules/employee/employee.types';
import { MatchedEmployee } from '@/modules/employer/components/Lockbox/lockbox.types';

const getFullStatusName = (firstLetter: keyof typeof StatusNames) => StatusNames[firstLetter];

interface Props {
  employeeId?: string;
  accountId?: string;
  enabled?: boolean;
}

const useGetMatchedEmployeeByIdQuery = ({ employeeId, accountId, enabled }: Props) => {
  const { data, isLoading } = useQuery(
    [API_URL.LOCKBOXES_MATCHED_EMPLOYEES_BY_EMPLOYEE_ID(employeeId || '')],
    () =>
      api.get(API_URL.LOCKBOXES_MATCHED_EMPLOYEES_BY_EMPLOYEE_ID(employeeId || ''), {
        params: {
          ...(accountId ? { account_id: accountId } : {}),
        },
      }),
    {
      enabled: !!enabled,
    }
  );

  const foundEmployee: MatchedEmployee | undefined = useMemo(() => {
    if (!data?.data) {
      return;
    }

    return {
      employeeId: toString(data?.data?.employee_id),
      employeeName: data?.data?.employee_name,
      ssn: data?.data?.ssn,
      birthDate: data?.data?.birth_date,
      // TODO: the field is not exists in the DTO
      // @ts-ignore
      employmentStatus: getFullStatusName(data?.data?.employment_status as keyof typeof StatusNames),
      organizationId: toString(data?.data?.organization_id),
      organizationName: data?.data?.organization_name,
      accountId: toString(data?.data?.account_id),
      accountNumber: data?.data?.account_number,
      // TODO: the field is not exists in the DTO
      // @ts-ignore
      availableAmount: data?.data?.available_amount,
      // TODO: the field is not exists in the DTO
      // @ts-ignore
      investmentsBalance: data?.data?.investments_balance,
      // TODO: the field is not exists in the DTO
      // @ts-ignore
      accountStatus: data?.data?.account_status,
      // TODO: the field is not exists in the DTO
      // @ts-ignore
      investmentStatus: data?.data?.investment_status,
      // TODO: the field is not exists in the DTO
      // @ts-ignore
      labelTypes: data?.data?.label_types,
      // TODO: the field is not exists in the DTO
      // @ts-ignore
      mailingAddress: data?.data?.mailing_address
        ? {
            // @ts-ignore
            line1: data?.data?.mailing_address?.line1,
            // @ts-ignore
            line2: data?.data?.mailing_address?.line2 ?? undefined,
            // @ts-ignore
            city: data?.data?.mailing_address?.city,
            // @ts-ignore
            state: data?.data?.mailing_address?.state,
            // @ts-ignore
            zipcode: data?.data?.mailing_address?.zipcode,
          }
        : undefined,
    };
  }, [data]);

  return {
    foundEmployee,
    isLoading,
  };
};

export default useGetMatchedEmployeeByIdQuery;
